import React from "react";
import PageHero from "../components/PageHero";
import ServicesGrid from "../components/ServicesGrid";
import IndustriesGrid from "../components/IndustriesGrid";
import ComplianceBadges from "../components/ComplianceBadges";
import CyberRiskCTA from "../components/CyberRiskCTA";
import TechPartners from "../components/TechPartners";
import AssessmentTimeline from "../components/AssessmentTimeline";
import OEMShowcase from "../components/OEMShowcase";

export default function SolutionsPage() {
  return (
    <div data-testid="solutions-page">
      <PageHero
        eyebrow="Solutions"
        title="Integrated cybersecurity solutions — engineered for resilience."
        subtitle="Strategy, architecture, delivery and managed operations. Consulting-led programs paired with best-of-breed OEM technology across identity, cloud, data, network and endpoint — vendor-neutral, framework-aligned, business-outcome first."
      />
      <ServicesGrid />
      <OEMShowcase />
      <IndustriesGrid />
      <AssessmentTimeline />
      <ComplianceBadges />
      <TechPartners />
      <CyberRiskCTA />
    </div>
  );
}
